// Angular
import { Injectable } from '@angular/core';

// Libraries
import { BehaviorSubject, takeUntil } from 'rxjs';

// Models
import { AppCleanup } from '../../../models';

// Services
import { UserService } from '../../../../modules/user/services/user.service';

// Configs
import { MenuConfig } from '../../../config/menu.config';

// Enums
import { StatusType } from '../../../enums';

@Injectable()
export class SideNavService extends AppCleanup {
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

	constructor(private userService: UserService) {
		super();
		this.loadMenu();
	}

	loadMenu() {
		const menuItems: any[] = new MenuConfig().menuItems.filter((m) => !m.hidden);

		if (!this.isViewer) {
			this.userService
				.getPendingUsersForUser()
				.pipe(takeUntil(this.destroy))
				.subscribe((pendingUserCount) => {
					if (pendingUserCount > 0) {
						menuItems.find((item) => item.title === 'Companies').badge = {
							type: StatusType.DANGER,
							value: pendingUserCount,
							label: 'pending users',
						};
					}
				});
		}

		this.menuList$.next(menuItems);
	}
}
